// import { PaymentMethods, PaymentMethodsTranslate } from '@/enums';
import { Actions } from 'vuex-smart-module';
import { Filters, FiltersPagination, BaseResponse } from '@/types';
import { Staffs } from '@/modules/staffs/types/';
import { AxiosResponse } from 'axios';
import { CompaniesUsersService } from '../../../services';
import CompanyUserStaffGetters from './getters';
import CompanyUserStaffMutations from './mutations';
import CompanyUserStaffState from './state';
import { CompaniesUsers } from '../../../types';

const companiesUsersService = new CompaniesUsersService();

export default class CompanyUserStaffActions extends Actions<
CompanyUserStaffState,
CompanyUserStaffGetters,
CompanyUserStaffMutations,
CompanyUserStaffActions
> {
  // получение данных о компаниях-пользователях ЛКП с сервера

  async get_company_user_staff(id: number | string) {
    try {
      const {
        sortBy = [], sortDesc = [], page = 1, itemsPerPage = 10,
      } = this.state.table_options;

      const payload: FiltersPagination<Filters> = {
        filters: this.state.filters,
        pagination: {
          limit: itemsPerPage,
          page,
          sort: '',
          sort_type: 'asc',
        },
      };

      if (sortBy?.length) {
        [payload.pagination.sort] = sortBy;
      }

      if (sortDesc?.length) {
        payload.pagination.sort_type = sortDesc[0] ? 'desc' : 'asc';
      }

      this.mutations.TOGGLE_LOADING_COMPANY_USER_STAFF(true);
      const { data, meta, code } = await companiesUsersService.get_company_user_staff(payload, id);

      this.mutations.SET_COMPANY_USER_STAFF(data.items);
      this.mutations.SET_CURRENT_USER_COMPANY(data.company);
      this.mutations.UPD_TABLE_OPTIONS({ key: 'itemsPerPage', value: meta.limit });
      this.mutations.UPD_TABLE_OPTIONS({ key: 'page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'current_page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_pages', value: meta.total_pages });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_items', value: meta.total_items });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'limit', value: meta.limit });
      return code;
    } catch (error) {
      console.log(error);
    } finally {
      this.mutations.TOGGLE_LOADING_COMPANY_USER_STAFF(false);
    }
  }

  async update_manager_details(data: {company_id: number, payload: CompaniesUsers.StaffPayloadAdmin}) {
    try {
      const { success } = await companiesUsersService.update_manager_details(data);

      return success;
    } catch (error) {
      console.log(error);
    }
  }

  async update_staff_details(payload: CompaniesUsers.StaffPayloadAdmin) {
    try {
      const { editable_staff } = this.state;
      const { success } = await companiesUsersService.update_staff_details(payload);

      this.mutations.SET_CURRENT_STAFF(editable_staff);
      this.mutations.RESET_EDITABLE_STAFF();
      return success;
    } catch (error) {
      console.log(error);
    }
  }

  async toggle_activity_staff_admin(payload: CompaniesUsers.StaffPayloadAdmin) {
    try {
      const { code } = await companiesUsersService.update_staff_details(payload);

      return code;
    } catch (error) {
      console.log(error);
      return (error as AxiosResponse);
    }
  }
}
